import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useContent } from "@/context/ContentContext";
import { ServiceCard } from "@/components/shared/ServiceCard";
import { OrderModal } from "@/components/shared/OrderModal";
import { PageHeader } from "@/components/shared/DashKit";
import { Loader2, RefreshCw } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function Refill() {
  const { t } = useContent();
  const [items, setItems] = useState([]);
  const [platforms, setPlatforms] = useState([]);
  const [categories, setCategories] = useState([]);
  const [f, setF] = useState({ platform_id: "", category_id: "" });
  const [loading, setLoading] = useState(true);
  const [service, setService] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => { api.get("/platforms").then((r) => setPlatforms(r.data)); }, []);
  useEffect(() => {
    if (f.platform_id) api.get(`/categories?platform_id=${f.platform_id}`).then((r) => setCategories(r.data));
    else setCategories([]);
  }, [f.platform_id]);

  const load = useCallback(async () => {
    setLoading(true);
    const p = new URLSearchParams({ refill: "true", limit: "60" });
    if (f.platform_id) p.append("platform_id", f.platform_id);
    if (f.category_id) p.append("category_id", f.category_id);
    const { data } = await api.get(`/services?${p.toString()}`);
    setItems(data.items); setLoading(false);
  }, [f]);
  useEffect(() => { load(); }, [load]);

  const set = (k, v) => setF((s) => ({ ...s, [k]: v === "all" ? "" : v, ...(k === "platform_id" ? { category_id: "" } : {}) }));

  return (
    <div>
      <PageHeader title={t("client.refill.title", "Refill / Recharge")} subtitle={t("client.refill.subtitle", "Services garantis avec recharge en cas de chute. Recommandez celui de votre choix.")} />

      <div className="mb-5 flex flex-col gap-2 rounded-xl border border-border bg-card p-4 sm:flex-row sm:items-center">
        <Select value={f.platform_id || "all"} onValueChange={(v) => set("platform_id", v)}>
          <SelectTrigger data-testid="refill-platform" className="sm:w-56"><SelectValue placeholder={t("services.filter.platform", "Plateforme")} /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">{t("services.filter.all", "Toutes")}</SelectItem>
            {platforms.map((p) => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}
          </SelectContent>
        </Select>
        <Select value={f.category_id || "all"} onValueChange={(v) => set("category_id", v)} disabled={!f.platform_id}>
          <SelectTrigger data-testid="refill-category" className="sm:w-56"><SelectValue placeholder={t("services.filter.category", "Catégorie")} /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">{t("services.filter.all", "Toutes")}</SelectItem>
            {categories.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      {loading ? (
        <div className="py-16 text-center"><Loader2 className="mx-auto h-6 w-6 animate-spin text-accent" /></div>
      ) : items.length === 0 ? (
        <div className="flex flex-col items-center gap-2 rounded-2xl border border-dashed border-border p-14 text-center text-muted-foreground">
          <RefreshCw className="h-7 w-7" /> {t("client.refill.empty", "Aucun service avec recharge pour le moment.")}
        </div>
      ) : (
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="refill-grid">
          {items.map((s) => <ServiceCard key={s.id} service={s} onOrder={(sv) => { setService(sv); setOpen(true); }} />)}
        </div>
      )}
      <OrderModal service={service} open={open} onClose={() => setOpen(false)} />
    </div>
  );
}
